export default class MissingMeetingInformationException {
  public message: string
  constructor(message: string) {
    this.message = message
  }
}
